import Dropdownable from 'components/dropdownable'

class ProfileAgent extends Dropdownable {
  init () {
    this.mainClass = 'core-ProfileAgent'
  }
}

export default ProfileAgent
